import videojs from "video.js";

const Component = videojs.getComponent("Component");
const Button = videojs.getComponent("Button");

/**
 * The base class for buttons
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends Button
 * @class StatsForNerdsCloseButton
 */
class StatsForNerdsCloseButton extends Button
{
	/**
	 * Creates an instance of this class.
	 *
	 * @param {Player} player
	 *		The `Player` that this class should be attached to.
	 *
	 * @param {Object} [options={}]
	 *		The key/value store of player options.
	 *
	 * @param {StatsForNerdsOverlay} overlay
	 *		A reference to the overlay which this button will close
	 */
	constructor(player, options = {}, overlay)
	{
		super(player, options);
		this.player = player;

		this.overlay = overlay;
	}

	/**
	 * Builds the default DOM `className`.
	 *
	 * @return {string}
	 *		The DOM `className` for this object.
	 */
	buildCSSClass()
	{
		return `vjs-stats-for-nerds-close-button ${super.buildCSSClass()}`;
	}

	/**
	 * This gets called when an `StatsForNerdsCloseButton` is "clicked". See
	 * {@link ClickableComponent} for more detailed information on what a click can be.
	 *
	 * @param {EventTarget~Event} [event]
	 *		The `keydown`, `tap`, or `click` event that caused this function to be
	 *		called.
	 *
	 * @listens tap
	 * @listens click
	 */
	handleClick()
	{
		super.handleClick();

		this.overlay.hide();
	}
}

/**
 * The text that should display over the `StatsForNerdsCloseButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */
StatsForNerdsCloseButton.prototype.controlText_ = "Close";

Component.registerComponent("statsForNerdsCloseButton", StatsForNerdsCloseButton);

export default StatsForNerdsCloseButton;
